import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiPopover from '@material-ui/core/Popover';

const Popover = ({
  open,
  anchorEl,
  anchorOrigin,
  transformOrigin,
  children,
  onClose,
  PaperProps,
}) => {
  // Components props
  let popoverProps = { open, anchorEl, onClose };

  if (anchorOrigin) {
    popoverProps = { ...popoverProps, anchorOrigin };
  }

  if (transformOrigin) {
    popoverProps = { ...popoverProps, transformOrigin };
  }

  if (PaperProps) {
    popoverProps = { ...popoverProps, PaperProps };
  }

  return (
    <MuiPopover {...popoverProps}>
      {children}
    </MuiPopover>
  );
};

Popover.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }),
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }),
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  PaperProps: PropTypes.shape({
    style: PropTypes.object,
  }),
};

Popover.defaultProps = {
  anchorEl: null,
  anchorOrigin: null,
  transformOrigin: null,
  PaperProps: null,
};

export default React.memo(Popover);



// WEBPACK FOOTER //
// ./components/core/Popover.js